/* eslint-disable react/jsx-no-duplicate-props */
/* eslint-disable no-unused-expressions */
import React from 'react';
import { Controller } from 'react-hook-form';
import TextField from '@material-ui/core/TextField';
import FormControl from '@material-ui/core/FormControl';

const CustomInput = (props) => {
  const {
    label, name, type, className, classes, disabled,
    required, multiline, rows, control, rule, error,
    defaultValue, onBlur, inputProps, id, onValidate,
    styleTextField, styleFromHelperText, InputPropsParam,
    onKeyDown, style, cleanInputPattern, blockComposing,
  } = props;

  return (
    <FormControl className={className} style={style} fullWidth>
      <Controller
        render={({ value, onChange }) => (
          <TextField
            label={label}
            id={id}
            size="small"
            type={type}
            fullWidth
            variant="outlined"
            multiline={multiline}
            rows={rows}
            value={value}
            style={styleTextField}
            error={Boolean(error[name])}
            disabled={disabled}
            required={required}
            onChange={((e) => {
              let originalValue = e.target.value;
              if (
                cleanInputPattern
                && cleanInputPattern instanceof RegExp
                && (!e.nativeEvent.isComposing || blockComposing)
              ) {
                originalValue = originalValue.replace(cleanInputPattern, '');
              }
              onChange(originalValue);
              onValidate && (onValidate(originalValue));
            })}
            inputProps={inputProps}
            InputProps={InputPropsParam}
            FormHelperTextProps={styleFromHelperText || { style: { margin: '0 0 0 5px', color: '#d61103' } }}
            helperText={error[name] ? error[name].message : null}
            onKeyDown={onKeyDown}
            className={classes}
            onBlur={onBlur}
          />
        )}
        name={name}
        control={control}
        rules={rule}
        error={Boolean(error[name])}
        defaultValue={defaultValue || ''}
      />
    </FormControl>
  );
};

export default CustomInput;
